<template>
  <a href="javascript:;" class="" @click="goToPage">
    <!-- <img :src="src" class="img"/> -->
    <el-image class="img" :src="src" fit="cover"></el-image>
    <el-image class="mobileImg" :src="mobileOpenPageUrl" fit="cover"></el-image>

          
    </a>
</template>
<script>
import { getBase } from '@/api/common.js';
export default {
  data() {
    return {
      src: '',
      mobileOpenPageUrl:'',
      times:3, 
    }
  },
  created() {
    this.getInfo(0);
    this.getTime();

  },
  methods: {
    async getInfo(val) {
      await getBase(val).then(res => {
        const data  = res.data;
        document.title = data.base.name;
        this.src = data.base.openPageUrl;
        this.mobileOpenPageUrl = data.base.mobileOpenPageUrl;
      })
    },
    goToPage() {
      setTimeout(() => {
          this.$router.push({
            name: 'HOMEINDEX',
            query: { languageId: 1 }
          });
      }, 2000)
    },
    getTime() {
      this.timer = setInterval(()=>{
        this.times--;
        if(this.times===0){
          this.goToPage();
          clearInterval(this.timer)
        }
      },1000)
    },
    mounted() {
      let screenWidth = document.documentElement.clientWidth;
      if (screenWidth <=768) {
          this.isCollapse = true;
      } else {
          this.isCollapse = false;
      }
    },
  }  
}
</script>

<style lang="less" scoped>
  .img, .mobileImg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: none;
    width: 100%;
    height: 100%;
  }
  .mobileImg {
      display: block;
  }
  a:focus .img,  a:focus .mobileImg{
    animation:mymove 3s infinite;
  }
  @keyframes mymove
  {
    from {top:0px;opacity: 1}
    to {top:-200px;opacity: 0}
  }

  @media (min-width: 768px){
    .img {
      display: block;
    }
    .mobileImg {
        display: none;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/init/init.vue